import { produce } from 'immer'
import type { State } from '../../typings'

export function setOtherProducer(state: State, payload: string): State {
  return produce(state, (draft) => {
    draft.referralOther = payload
  })
}
